import { useSelector } from 'react-redux';
import { MediaBanner } from './MediaBanner';
import { TMainpageBrandContext } from '../NewAdfoxBanner/bannerTypes';
import { shouldNewFiltersShow } from '../../utils/filters';
import { useMainPageBrandBannerEnrichments } from './useMainPageBrandBannerEnrichments';
import React, { FC, useMemo } from 'react';
import { IApplicationState } from '../../types/redux';
import DOMPurify from 'isomorphic-dompurify';

type TMediaBannerContainerProps = {
  context: TMainpageBrandContext;
};

const shouldNewFiltersShowSelector = (state: IApplicationState) =>
  shouldNewFiltersShow({ section: state.page.section });

export const MediaBannerContainer: FC<TMediaBannerContainerProps> = ({ context }) => {
  const {
    info,
    url,
    logoImageUrl,
    substrateNotNeeded,
    name,
    actionText,
    phone,
    buttonText,
    label,
    mortgageWarning,
    mortgageTermsWarning,
  } = context;

  const hasNewPlacement = useSelector(shouldNewFiltersShowSelector);

  const mainPageBrandBannerEnrichments = useMainPageBrandBannerEnrichments(context);

  const sanitizedName = useMemo(() => name && DOMPurify.sanitize(name), [name]);
  const sanitizedPhone = useMemo(() => phone && DOMPurify.sanitize(phone), [phone]);
  const sanitizedActionText = useMemo(() => actionText && DOMPurify.sanitize(actionText), [actionText]);
  const sanitizedInfo = useMemo(() => {
    const infoText = mainPageBrandBannerEnrichments?.title || info;

    return infoText && DOMPurify.sanitize(infoText);
  }, [info, mainPageBrandBannerEnrichments?.title]);

  return (
    <MediaBanner
      hasNewPlacement={hasNewPlacement}
      sanitizedInfo={sanitizedInfo}
      mortgageTermsWarning={mortgageTermsWarning}
      mortgageWarning={mortgageWarning}
      label={label}
      buttonText={buttonText}
      sanitizedPhone={sanitizedPhone}
      sanitizedActionText={sanitizedActionText}
      sanitizedName={sanitizedName}
      substrateNotNeeded={substrateNotNeeded === '1'}
      logoImageUrl={logoImageUrl}
      url={url}
    />
  );
};
